export default __webpack_public_path__ + "static/media/olsonHeadshot.43f36abb.webp";